@if (conversationDetail$ | async) {
  <div
    class="messages-top-bar"
    [ngClass]="{ 'sidebar__messages-top-bar': (useSidebarStyles$ | async) }"
    >
    @if ($showInboxBack()) {
      <div class="icon-back" [ngClass]="{ 'sidebar__icon-back': useSidebarStyles$ | async }" (click)="back()">
        <span class="material-icons">arrow_back</span>
      </div>
    }
    <div class="messages-recipient">
      <div class="recipient-info">
        <div class="conversation-title" [ngClass]="{ 'clickable-title': canAccessInboxSidebar() }">
          <inbox-conversation-title
            [conversationDetail]="conversationDetail$ | async"
            [conversationClosed]="!isOpen"
            [displayOnTopBar]="true"
            (click)="toggleDetailsDrawer()"
          ></inbox-conversation-title>
        </div>
        <div class="recipient-details">
          @if (isInternalInfoDeleted) {
            <glxy-badge [color]="'red'">{{ 'INBOX.INFO.DELETED' | translate }}</glxy-badge>
          }
          @if (canAccessInboxSidebar()) {
            <button mat-icon-button (click)="toggleDetailsDrawer()">
              <mat-icon class="info-pane-button">info_outlined</mat-icon>
            </button>
          }
        </div>
      </div>
      @if (isBusinessApp && !isMobile) {
        <inbox-conversation-account
          [conversationDetail]="conversationDetail$ | async"
        ></inbox-conversation-account>
      }
      @if (displayAssignee$ | async) {
        <inbox-conversation-assignee
          [conversationDetail]="conversationDetail$ | async"
        ></inbox-conversation-assignee>
      }
    </div>
    <div class="messages-actions">
      @if (showInboxViews$ | async) {
        <!-- Small Button -->
        <button
          attr.data-action="clicked-conversation-follow-{{ (useSidebarStyles$ | async) ? 'sidebar' : 'fullview' }}"
          class="follow-button icon-button"
          mat-icon-button
          (click)="updateFollowStatus()"
          [matTooltip]="(isFollowing ? 'INBOX.VIEWS.FOLLOWING' : 'INBOX.VIEWS.FOLLOW') | translate"
          [ngClass]="{ 'follow-button-mobile': (useSidebarStyles$ | async) === false }"
          >
          <mat-icon>{{ isFollowing ? 'star' : 'star_border' }}</mat-icon>
        </button>
        <!-- Large Button -->
        @if ((useSidebarStyles$ | async) === false) {
          <button
            attr.data-action="clicked-conversation-follow-{{ (useSidebarStyles$ | async) ? 'sidebar' : 'fullview' }}"
            class="follow-button follow-button-large"
            mat-stroked-button
            (click)="updateFollowStatus()"
            >
            <mat-icon>{{ isFollowing ? 'star' : 'star_border' }}</mat-icon>
            {{ (isFollowing ? 'INBOX.VIEWS.FOLLOWING' : 'INBOX.VIEWS.FOLLOW') | translate }}
          </button>
        }
      }
      @if ($showConversationOverlayButton()) {
        <button
          mat-icon-button
          class="menu-icon"
          (click)="openConversationOverlay()"
          [matTooltip]="'INBOX.CHAT.OPEN_SIDE_PANEL_TOOLTIP' | translate"
          >
          <mat-icon>flip_to_front</mat-icon>
        </button>
      }
      <button
        mat-icon-button
        class="icon-button"
        [matMenuTriggerFor]="menu"
        aria-label="More"
        data-action="clicked-menu-conversation-top-bar"
        >
        <mat-icon>more_vert</mat-icon>
      </button>
      <mat-menu #menu="matMenu">
        @if (!(unseen$ | async)?.read) {
          <button mat-menu-item (click)="markRead()" data-action="clicked-conversation-read">
            <span>{{ 'INBOX.SENDER.MARK_READ' | translate }}</span>
          </button>
        } @else {
          <button mat-menu-item (click)="markUnread()" data-action="clicked-conversation-unread">
            <span>{{ 'INBOX.SENDER.MARK_UNREAD' | translate }}</span>
          </button>
        }
        @if (!isBusinessApp) {
          <button mat-menu-item (click)="toggleDetailsDrawer()">
            {{ 'INBOX.INFO.CONVERSATION_DETAILS' | translate }}
          </button>
        }
        <!-- Kabob Dynamic Available Actions -->
        @for (action of kabobAvailableActions$ | async; track action) {
          <button mat-menu-item (click)="action.action()" [attr.data-action]="action.posthogLabel">
            <span>{{ action.title | translate }}</span>
          </button>
        }
        @if (showInboxViews$ | async) {
          <button mat-menu-item (click)="updateFollowStatus()" class="icon-button">
            <div class="button-content">
              {{ (isFollowing ? 'INBOX.VIEWS.FOLLOWING' : 'INBOX.VIEWS.FOLLOW') | translate }}
              <mat-icon>{{ isFollowing ? 'star' : 'star_border' }}</mat-icon>
            </div>
          </button>
        }
        @if (showAIResponseToggle$ | async) {
          <button mat-menu-item (click)="toggleAIResponseStatus()">
            {{
            (aiResponseStatus() ? 'INBOX.SENDER.TURN_OFF_AI_REPLIES' : 'INBOX.SENDER.TURN_ON_AI_REPLIES') | translate
            }}
          </button>
        }
        @if ($showCloseConversationButton()) {
          <button mat-menu-item (click)="toggleConversationOpen()">
            {{ (isOpen ? 'INBOX.SENDER.MARK_AS_CLOSED' : 'INBOX.SENDER.OPEN_CONVERSATION') | translate }}
          </button>
        }
      </mat-menu>
      @if (isConversationOverlayMode()) {
        <button mat-icon-button class="menu-icon close" (click)="closeConversationOverlay()">
          <mat-icon>close</mat-icon>
        </button>
      }
    </div>
  </div>
}
